/**
 * Focus and viewport helpers for a modal dialog that renders as a bottom sheet on a phone.
 * Each watcher returns a function that stops it.
 */

// ConfirmModal and the call screens stack above the dialog and own focus and keys while they show.
export function belongsToOtherDialog(target, overlay) {
    if (window.ConfirmModal?.activeModal) return true;
    const surface = target && typeof target.closest === 'function'
        ? target.closest('[aria-modal="true"], [data-call-surface]')
        : null;

    return Boolean(surface && surface !== overlay);
}

// Focus that leaves the dialog for the page behind it goes back through onStray.
export function guardDialogFocus(getOverlay, onStray) {
    const handler = (event) => {
        const overlay = getOverlay();
        if (!overlay || overlay.contains(event.target) || belongsToOtherDialog(event.target, overlay)) return;
        onStray();
    };
    document.addEventListener('focusin', handler);

    return () => document.removeEventListener('focusin', handler);
}

// A sheet pinned to the layout viewport sits under the on-screen keyboard, so onChange gets the
// keyboard height. A pinch zoom also shrinks the visual viewport and reports 0.
export function watchKeyboardInset(onChange) {
    const viewport = window.visualViewport;
    if (!viewport) return () => {};
    const update = () => {
        const zoomed = Math.abs((viewport.scale || 1) - 1) > 0.01;
        onChange(zoomed ? 0 : Math.max(0, Math.round(window.innerHeight - viewport.height - viewport.offsetTop)));
    };
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    update();

    return () => {
        viewport.removeEventListener('resize', update);
        viewport.removeEventListener('scroll', update);
        onChange(0);
    };
}
